import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';

import { I18nService } from '@personal-area/global/i18n';
import { ButtonComponent } from '@personal-area/global/ui'
import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';
import { CardWrapperModule } from '@personal-area/global/ui';
import { map, of, startWith, take, timeout, filter } from 'rxjs';

import {
  SkipData,
  SkipVerificationDialogComponent,
} from '../../components/skip-verification-dialog/skip-verification-dialog.component';
import { IDVerificationStatus } from '../../models/verification-profile-response';
import { SummaryVerificationFacade } from '../../state/facades/summary';
import { DepositBonusFacade } from '@personal-area/global/deposit-bonus';
import { AccountsFacade } from '@personal-area/global/accounts/services';

@Component({
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    LetDirective,
    ButtonComponent,
    CardWrapperModule,
    IconSpriteModule,
    TranslateModule,
    RouterModule,
  ],
})
export class RouteComponent implements OnInit {
  private _depositBonusFacade = inject(DepositBonusFacade);
  private _accountsFacade = inject(AccountsFacade);

  public selectedAccount$ = this._accountsFacade.getSelectedAccount$;
  public depositBonusAvailability$ = this._depositBonusFacade.depositBonusAvailability$;
  public idRejected$ = this._summaryFacade.summary$.pipe(
    map((profile) => profile?.idStatus === IDVerificationStatus.rejected),
    startWith(null),
    take(2),
    timeout({ each: 1000, with: () => of(false) }),
  );

  constructor(
    private _summaryFacade: SummaryVerificationFacade,
    private _dialog: MatDialog,
    private _i18nService: I18nService,
  ) {
  }

  public ngOnInit(): void {
    const lang = this._i18nService.languageA2;

    this.selectedAccount$
      .pipe(
        filter(Boolean),
        take(1)
      )
      .subscribe((account) => {
        this._depositBonusFacade.getDepositBonusAvailability(account.id, lang);
      });
  }

  public promptSkip(): void {
    this._dialog.open(SkipVerificationDialogComponent, <MatDialogConfig<SkipData>>{
      panelClass: 'regular-popup-container',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      data: {
        text: 'verification-modal.text.skip.route',
      },
    });
  }
}
